export default {
	name: 'lv-scope-slot',
	props: {
		scopeSlotFunc: {
			type: Function,
			required: true
		},
		data: {},
		tag: {type: String, default: 'div'},
	},
	render(h) {
		const {tag: Tag} = this
		return (
			<Tag class="lv-scope-slot">
				{!!this.scopeSlotFunc && this.scopeSlotFunc(this.data)}
			</Tag>
		)
	},
}
